import { Component, ReactNode } from 'react';
import { ChartFragment, FileFragment } from 'models/api-response';
import { SectionNavIdPatterns } from 'constants/app.constant';
import { dateTimeHelper } from 'helpers';
import { chartService } from 'services';
import { SavedPatientCharting } from 'components/common';
import { TableItem } from 'components/common/saved-patient-charting/SavedPatientCharting';
import FileChartPanel from './file-chart/FileChartPanel';
import { FILE_NAV_ID, FileChartText } from './file-chart/constants';
import { isFileFragment } from './file-chart/helper';

class SavedSpecialCharts extends Component {
  static displayName = 'SavedSpecialCharts';

  toTableData = (fragments: ChartFragment[]): TableItem[] =>
    fragments.map((fragment) => ({
      active: fragment.active,
      chart: isFileFragment(fragment) ? (fragment as FileFragment).chartData.fileTitle : fragment.chartData.fragmentTitle,
      chartSection: isFileFragment(fragment) ? FileChartText.CHART_SECTION : fragment.chartData.chartTitle,
      enteredBy: chartService.formatName(fragment.creator),
      entryTime: dateTimeHelper.toDateTime(fragment.chartingAt),
      // SIMSNG-6232: FILE rows hide Entry Time in this table; retain the timestamp in row data.
      hideEntryTime: isFileFragment(fragment),
      fragmentCreatorId: fragment.creator?.id,
      fragmentType: fragment.fragmentType,
      id: fragment.fragmentId,
      linkedFragmentId: fragment.linkedFragmentId,
      navElementId: fragment.navElementId
    }));

  // Uploaded files are not editable chart records, so they get a viewer instead of <EditChart>.
  renderPanelBody = (fragment: ChartFragment): ReactNode => (isFileFragment(fragment) ? <FileChartPanel selectedFragment={fragment as FileFragment} /> : null);

  // An uploaded file is reference material, so it stays visible after the assessment is submitted.
  isAlwaysVisibleFragment = (fragment: ChartFragment): boolean => isFileFragment(fragment);

  render() {
    const viewProps = {
      chartTitle: 'Saved Special Charts',
      navIds: [SectionNavIdPatterns.SPECIAL_CHARTS, FILE_NAV_ID],
      toTableData: this.toTableData,
      renderPanelBody: this.renderPanelBody,
      isAlwaysVisibleFragment: this.isAlwaysVisibleFragment
    };
    return <SavedPatientCharting {...this.props} {...viewProps} />;
  }
}

export default SavedSpecialCharts;
